(function () {
  'use strict'

  function observeCards (cards, root = null) {
    if (!cards.length) return

    const visibleThreshold = 0.2
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const card = entry.target
        const isVisible = entry.isIntersecting && entry.intersectionRatio >= visibleThreshold

        if (isVisible) {
          card.classList.add('nail-colors-showcase__card--animated')
          card.style.setProperty('--animation-progress', 1)
        } else {
          card.classList.remove('nail-colors-showcase__card--animated')
          card.style.setProperty('--animation-progress', 0)
        }
      })
    }, {
      root,
      rootMargin: '0px',
      threshold: [0, visibleThreshold]
    })

    cards.forEach(card => observer.observe(card))
  }

  function initClipPathAnimation () {
    const cards = Array.from(document.querySelectorAll('.nail-colors-showcase__card'))

    if (!cards.length) return

    if (!('IntersectionObserver' in window)) {
      cards.forEach(card => {
        card.classList.add('nail-colors-showcase__card--animated')
        card.style.setProperty('--animation-progress', 1)
      })
      return
    }

    observeCards(cards)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClipPathAnimation)
  } else {
    initClipPathAnimation()
  }
})()

if (!customElements.get('nail-colors-showcase-carousel')) {
  customElements.define(
    'nail-colors-showcase-carousel',
    class NailColorsShowcaseCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.nail-colors-showcase__grid')
        this.pagination = this.querySelector('.swiper-pagination')
        this.runtimeFrame = null
        this.morphObserver = null
        this.mobileMediaQuery = window.matchMedia('screen and (max-width: 767px)')
        this.onBreakpointChange = this.syncCarousel.bind(this)

        this.mobileMediaQuery.addEventListener('change', this.onBreakpointChange)
        this.syncCarousel()
      }

      disconnectedCallback() {
        this.mobileMediaQuery?.removeEventListener('change', this.onBreakpointChange)
        this.cancelRuntimeRetry()
        this.destroyCarousel()
      }

      syncCarousel() {
        if (!this.mobileMediaQuery.matches) {
          this.cancelRuntimeRetry()
          this.destroyCarousel()
          return
        }

        if (this.carousel || !this.viewport || !this.pagination) return

        if (!window.FoxTheme?.Carousel || !window.FoxTheme?.Swiper?.Autoplay) {
          this.queueRuntimeRetry()
          return
        }

        this.carousel = new window.FoxTheme.Carousel(this.viewport, {
          slidesPerView: 1,
          spaceBetween: 16,
          speed: 500,
          loop: true,
          threshold: 2,
          pagination: {
            el: this.pagination,
            clickable: true,
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
        }, [window.FoxTheme.Swiper.Autoplay])
        this.carousel.init()
        this.setupMorphObserver()
        this.cancelRuntimeRetry()
      }

      setupMorphObserver() {
        if (!this.viewport || !('IntersectionObserver' in window)) return

        this.destroyMorphObserver()
        const visibleThreshold = 0.2
        this.morphObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const card = entry.target
            const isVisible = entry.isIntersecting && entry.intersectionRatio >= visibleThreshold

            card.classList.toggle('nail-colors-showcase__card--animated', isVisible)
            card.style.setProperty('--animation-progress', isVisible ? 1 : 0)
          })
        }, {
          root: this.viewport,
          rootMargin: '0px',
          threshold: [0, visibleThreshold]
        })

        this.querySelectorAll('.nail-colors-showcase__card').forEach(card => {
          this.morphObserver.observe(card)
        })
      }

      destroyMorphObserver() {
        this.morphObserver?.disconnect()
        this.morphObserver = null
      }

      queueRuntimeRetry() {
        if (this.runtimeFrame !== null) return

        this.runtimeFrame = window.requestAnimationFrame(() => {
          this.runtimeFrame = null
          this.syncCarousel()
        })
      }

      cancelRuntimeRetry() {
        if (this.runtimeFrame === null) return

        window.cancelAnimationFrame(this.runtimeFrame)
        this.runtimeFrame = null
      }

      destroyCarousel() {
        if (!this.carousel?.slider) return

        this.destroyMorphObserver()
        this.carousel.slider.destroy(true, true)
        this.carousel = null
      }
    }
  )
}
